export const Endpoint = {
  forms: (id: string) => `forms/${id}`,
  responses: (id: string) => `forms/${id}/responses`,
};
